module.exports = __webpack_public_path__ + "media/nf_tagging.6d7bc41b.webm";